/* eslint-disable indent */
/* eslint-disable no-confusing-arrow */
import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import theme from '../../theme';

const IconSC = styled.svg.withConfig({
  shouldForwardProp: (prop) => prop !== 'clickable',
})`
  min-width: ${({ size }) => size}px;
  max-width: ${({ size }) => size}px;
  width: ${({ size }) => size}px;
  height: ${({ size }) => size}px;
  transform: rotate(0deg);
  //z-index: 1;
  cursor: ${({ clickable }) => (clickable ? 'pointer' : 'unset')};
  stroke: ${({ stroke, disabled }) =>
    disabled ? theme().colors.midGray : stroke};
  fill: ${({ fill, disabled }) =>
    disabled ? theme().colors.midGray : fill ?? 'none'} !important;
  stroke-width: ${({ strokeWidth }) => strokeWidth}px;
  margin-top: ${({ mt }) => mt}px;

  ${({ rotate }) =>
    rotate &&
    css`
      transform: rotate(${rotate}deg);
    `};

  ${({ position, top, left, bottom, right, rotate }) =>
    position === 'absolute'
      ? `
      position: absolute;
      top: ${top}px;
      left: ${left}px;
      bottom: ${bottom}px;
      right: ${right}px;
    `
      : position === 'center'
      ? `
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%) ${rotate ? `rotate(${rotate}deg)` : ''};
    `
      : null};

  transition: ${(props) => props.theme.constants.transitionBase};
`;

const Icon = ({
  position = 'relative',
  size = 20,
  fill = 'none',
  clickable = true,
  stroke = theme().colors.themeColor,
  strokeWidth = 2.6667,
  className = '',
  type,
  onClick,
  disabled,
  top,
  left,
  bottom,
  right,
  rotate,
  mt,
}) => {
  const handleOnclick = (e) => {
    if (onClick && !disabled) onClick(e);
  };
  return (
    <IconSC
      className={`icon-${type} ${className}`}
      position={position}
      top={top}
      left={left}
      bottom={bottom}
      right={right}
      onClick={handleOnclick}
      size={size}
      fill={fill}
      stroke={stroke}
      strokeWidth={strokeWidth}
      clickable={clickable}
      disabled={disabled}
      rotate={rotate}
      mt={mt}
    >
      <use xlinkHref={`#icon-${type}`} />
    </IconSC>
  );
};

Icon.propTypes = {
  type: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  position: PropTypes.oneOf(['absolute', 'relative', 'center']),
  size: PropTypes.number,
  fill: PropTypes.string,
  stroke: PropTypes.string,
  strokeWidth: PropTypes.number,
  rotate: PropTypes.number,
  clickable: PropTypes.bool,
  disabled: PropTypes.bool,
  top: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  right: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  bottom: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  left: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  className: PropTypes.string,
  mt: PropTypes.number,
};

export default Icon;
